export default __webpack_public_path__ + "hot.d1fac6c0.svg";